import {
  radioUI,
  radioSchema,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { marriageTypeOptions } from '../../../utils/labels';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    marriageType: radioUI({
      title: content['household-veteran-marriage-info-title'],
      labels: marriageTypeOptions,
      labelHeaderLevel: 3,
    }),
    typeOfMarriageExplanation: textUI({
      title: content['household-veteran-marriage-info-type'],
      required: formData => formData?.marriageType === 'other',
      errorMessages: {
        required: content['household-veteran-marriage-info-type-error'],
      },
      hint: content['household-veteran-marriage-info-type-hint'],
      maxLength: 256,
      expandUnder: 'marriageType',
      expandUnderCondition: 'other',
    }),
  },
  schema: {
    type: 'object',
    required: ['marriageType'],
    properties: {
      marriageType: radioSchema(Object.keys(marriageTypeOptions)),
      typeOfMarriageExplanation: customTextSchema,
    },
  },
};
